import { connect } from 'react-redux'
import _ from 'lodash'

import PopupTypes from '../popup_types'
import {
  closePopup,
  openPopup,
  updateCategory,
  createCategory,
  changeLeagueCategory,
  changeLeagueSeason,
  changeLeagueTour,
  updateOpenRegistrationStatus,
  getLeagueFieldData,
} from '../actions'
import CCPopupsComponent from '../components/popups/cc_popups_component'

const DEFAULT_COPY_OPTIONS = [
  'copy_managers',
  'copy_logos',
  'copy_all_portal_pages',
  'open_registration',
  'tournaments',
  'tournament_library',
  'golf_hub_page',
  'copy_dft',
  'rounds_and_series',
  'stripe_account',
  'registration_payment_options',
]

import {
  getLeagueRounds,
  getLeagueManagers,
  getCategoriesOptions,
  getSeasonsOptions,
  getToursOptions,
} from '../selectors'

const mapStateToProps = (state) => {
  const popupStates = state.popupStates

  const categoriesOptions = getCategoriesOptions(state)
  const changeCategory = {
    ...popupStates[PopupTypes.CHANGE_CATEGORY],
    categoriesOptions,
  }

  const seasonsOptions = getSeasonsOptions(state)
  const changeSeason = {
    ...popupStates[PopupTypes.CHANGE_SEASON],
    seasonsOptions,
  }

  const userIsTourManager = state.misc.userIsTourManager
  const toursOptions = getToursOptions(state, { addEmptyOption: !userIsTourManager })
  const changeTour = {
    ...popupStates[PopupTypes.CHANGE_TOUR],
    toursOptions,
  }

  const cloneEventDates = _.cloneDeep(popupStates[PopupTypes.CLONE_EVENT_DATES])
  if (cloneEventDates.data && cloneEventDates.data.fromLeague) {
    cloneEventDates.data.rounds = getLeagueRounds(state, cloneEventDates.data.fromLeague)
  }
  cloneEventDates.formURL = state.misc.cloneLeagueURL

  const cloneEventCopyOptions = _.cloneDeep(popupStates[PopupTypes.CLONE_EVENT_COPY_OPTIONS])
  if (cloneEventCopyOptions.data && cloneEventCopyOptions.data.fromLeague) {
    const leagueId = cloneEventCopyOptions.data.fromLeague
    cloneEventCopyOptions.data.roundsCount = getLeagueRounds(state, leagueId).length
    cloneEventCopyOptions.data.managers = getLeagueManagers(state, leagueId)
    const league = state.misc.potentialCloneCandidate
    if (league.openRegistrationData) {
      cloneEventCopyOptions.data.hasOpenRegistration = league.openRegistrationData.hasOpenRegistration
    }
    cloneEventCopyOptions.data.stripeAccount = league.stripeAccount
    cloneEventCopyOptions.data.copyStripeAndFees = league.copyStripeAndFees
    cloneEventCopyOptions.data.isExpressEvent = league.isExpressEvent
    cloneEventCopyOptions.data.golfHubPage = league.golfHub !== ''
    cloneEventCopyOptions.data.golfHubRegistration = league.golfHubRegistration
  }
  cloneEventCopyOptions.formURL = state.misc.cloneLeagueURL

  const createEvent = {
    ...popupStates[PopupTypes.CREATE_EVENT],
    customerOnlyEvents: state.misc.customerOnlyEvents,
    formURL: state.misc.createLeagueURL,
    userIsGroupLeader: state.misc.userIsGroupLeader,
  }
  const cloneEvent = {
    ...popupStates[PopupTypes.CLONE_EVENT],
    customerOnlyEvents: state.misc.customerOnlyEvents,
    userIsGroupLeader: state.misc.userIsGroupLeader,
  }
  const quickEvent = {
    ...popupStates[PopupTypes.QUICK_EVENT],
    formURL: state.misc.createLeagueURL,
  }
  return {
    categoriesOptions,
    seasonsOptions,
    toursOptions,
    quickEvent,
    createEvent,
    cloneEvent,
    cloneEventCopyOptions,
    cloneEventDates,
    categoryPopup: popupStates[PopupTypes.CATEGORY_POPUP],
    invitationListRegistrationPopup: popupStates[PopupTypes.INVITATION_LIST_REGISTRATION],
    changeCategory,
    changeSeason,
    changeTour,
    canCreateDCP: state.misc.canCreateDCP,
    userIsAdmin: state.misc.userIsAdmin,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    closePopup: id => dispatch(closePopup(id)),
    updateCategory: data => dispatch(updateCategory(data.id, data)),
    createCategory: data => dispatch(createCategory(data)),
    changeLeagueCategory: (leagueId, toCategoryId) => {
      return dispatch(changeLeagueCategory(leagueId,
                                           toCategoryId))
    },
    changeLeagueSeason: (leagueId, seasonId) => dispatch(changeLeagueSeason(leagueId, seasonId)),
    changeLeagueTour: (leagueId, tourId) => dispatch(changeLeagueTour(leagueId, tourId)),
    updateOpenRegistrationStatus: (leagueId, status, skipNotifications) =>
      dispatch(updateOpenRegistrationStatus(leagueId, status, skipNotifications)),
    advanceToCopyOptions: (data) => dispatch((innerDispatch, getState) => {
      if (getState().misc.userIsGroupLeader) {
        innerDispatch(openPopup(PopupTypes.CLONE_EVENT_DATES, { ...data, copyOptions: DEFAULT_COPY_OPTIONS }))
      } else {
        innerDispatch(openPopup(PopupTypes.CLONE_EVENT_COPY_OPTIONS, data))
      }
    }),
    advanceToDates: (data) => dispatch(openPopup(PopupTypes.CLONE_EVENT_DATES, data)),
    getLeagueFieldData: (name) => dispatch(getLeagueFieldData(name)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CCPopupsComponent)
